import { differenceInCalendarDays, format } from 'date-fns'

export const calculateDaysAgo = (dateInput: string | number | Date) => {
  const targetDate = new Date(dateInput)
  const today = new Date()
  const difference = differenceInCalendarDays(today, targetDate)
  return difference
}

export const formatDate = (dateInput: string | number | Date) => {
  const targetDate = new Date(dateInput)
  const formattedDate = format(targetDate, 'yyyy-MM-dd HH:mm:ss')
  return formattedDate
}
